module.exports = __webpack_public_path__ + "static/media/1.874c3d89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16017/1.jpg
// module id = 509
// module chunks = 0